export default __webpack_public_path__ + "static/media/juegosemanas_instrucciones.2e44f085.png";